import React, { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const ANALYSTS = ["Dan", "Evan", "Ian", "James"];
const COLOR = "hsl(218, 65%, 42%)";

export default function AnalystChart({ races }) {
  const data = useMemo(() => {
    const counts = {};
    ANALYSTS.forEach((a) => { counts[a] = 0; });
    races.forEach((r) => {
      const da = r._ad?.data_analyst;
      if (da && counts[da] !== undefined) counts[da]++;
    });
    return Object.entries(counts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  }, [races]);

  return (
    <div className="bg-card border border-border rounded-lg p-5 space-y-3">
      <p className="text-sm font-semibold">Races by Data Analyst</p>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data} layout="vertical" margin={{ left: 10, right: 20, top: 0, bottom: 0 }}>
          <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="hsl(220,16%,90%)" />
          <XAxis type="number" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} allowDecimals={false} />
          <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} tickLine={false} axisLine={false} width={40} />
          <Tooltip
            cursor={{ fill: "hsl(220,16%,96%)" }}
            contentStyle={{ fontSize: 12, border: "1px solid hsl(220,16%,88%)", borderRadius: 6 }}
          />
          <Bar dataKey="count" name="Races" radius={[0, 4, 4, 0]} fill={COLOR} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}